import { useQuery } from "@tanstack/react-query";
import { listArtists, type ArtistSearchParams } from "../api/artistsApi";
import { queryKeys } from "../lib/queryKeys";

export function useArtistsList(params: ArtistSearchParams) {
  return useQuery({
    queryKey: queryKeys.artists.list(params as Record<string, unknown>),
    queryFn: () => listArtists(params),
  });
}
